import { render, staticRenderFns } from "./_article.vue?vue&type=template&id=1b1011b4&scoped=true&"
import script from "./_article.vue?vue&type=script&lang=js&"
export * from "./_article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1011b4",
  null
  
)

export default component.exports